var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _c("div", { staticClass: "form-controls pr-1 pl-1 pb-2" }, [
      _vm.validationErrors.length > 0
        ? _c("div", { staticClass: "alert alert-error" }, [
            _c(
              "ul",
              _vm._l(_vm.validationErrors, function (error, i) {
                return _c("li", { key: i }, [_vm._v(_vm._s(error))])
              }),
              0
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "label",
          { staticClass: "form-label", attrs: { for: "chartType" } },
          [_vm._v(_vm._s(_vm.$t("chartType")))]
        ),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.chartType,
                expression: "chartType",
              },
            ],
            staticClass: "form-control",
            attrs: { id: "chartType" },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.chartType = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function ($event) {
                  return _vm.chartTypeChanged()
                },
              ],
            },
          },
          _vm._l(_vm.chartTypeConfigs, function (option) {
            return _c(
              "option",
              { key: option.type, domProps: { value: option } },
              [_vm._v(" " + _vm._s(_vm.$t("chartTypes." + option.type)) + " ")]
            )
          }),
          0
        ),
      ]),
      _vm.chartType.numKpis == 0
        ? _c("div", [
            _c("label", { attrs: { for: "kpi1" } }, [
              _vm._v(_vm._s(_vm.$t("kpi1"))),
            ]),
            _c("div", { staticClass: "alert alert-info" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("kpiSelectionNotAvailableForThisChartType")) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      _vm.chartType.numKpis > 0
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "kpi1" } }, [
              _vm._v(_vm._s(_vm.$t("kpi1"))),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedKpi1,
                    expression: "selectedKpi1",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "kpi1" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedKpi1 = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { disabled: "", value: "0" } }, [
                  _vm._v(_vm._s(_vm.$t("emptyOption"))),
                ]),
                _vm._l(_vm.kpis, function (option) {
                  return _c(
                    "option",
                    { key: option.id, domProps: { value: option.id } },
                    [_vm._v(" " + _vm._s(option.name) + " ")]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.chartType.numKpis > 1
        ? _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "kpi2" } }, [
              _vm._v(_vm._s(_vm.$t("kpi2"))),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedKpi2,
                    expression: "selectedKpi2",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "kpi2" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedKpi2 = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { disabled: "", value: "0" } }, [
                  _vm._v(_vm._s(_vm.$t("emptyOption"))),
                ]),
                _vm._l(_vm.kpis, function (option) {
                  return _c(
                    "option",
                    { key: option.id, domProps: { value: option.id } },
                    [_vm._v(" " + _vm._s(option.name) + " ")]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "comment" } }, [
          _vm._v(_vm._s(_vm.$t("comment"))),
        ]),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.comment,
              expression: "comment",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "comment" },
          domProps: { value: _vm.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.comment = $event.target.value
            },
          },
        }),
      ]),
    ]),
    _c("div", { staticClass: "flex-row footer-container" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-default mr-2",
          on: {
            click: function ($event) {
              return _vm.$emit("close", { reason: "cancel" })
            },
          },
        },
        [_vm._v(" Cancel ")]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-default",
          on: {
            click: function ($event) {
              return _vm.saveChanges()
            },
          },
        },
        [_vm._v(" Save ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }